export const mapImmigrationToForm = (data: any) => ({
    id: data?.id ?? null,
    immigration_id: data?.immigration_id ?? null,

    company_id: data?.company_id ?? null,
    company_value: data?.company?.company_name ?? "",

    employee_id: data?.employee_id ?? null,
    employee_value: data?.employee
        ? `${data.employee.first_name} ${data.employee.last_name}`
        : "",
    employee_code: data?.employee?.custome_code ?? "",
    employee_user_id: data?.employee?.user_id ?? "",

    nationality_id: data?.nationality_id ?? null,
    nationality_value: data?.nationality?.name ?? "",

    host_country_id: data?.host_country_id ?? null,
    host_country_value: data?.host_country?.name ?? "",

    home_country_id: data?.home_country_id ?? null,
    home_country_value: data?.home_country?.name ?? "",

    employer_entity: data?.employer_entity ?? null,

    assignment_type_id: data?.assignment_type_id ?? null,
    assignment_type_value: data?.assignment_type?.assignment_type_value ?? "",

    assignment_start_date: data?.assignment_start_date ?? "",
    assignment_end_date: data?.assignment_end_date ?? "",

    immigration_status_id: data?.immigration_status_id ?? null,
    immigration_status_value:
        data?.immigration_status?.immigration_status_value ?? "",

    applications: data?.applications ?? [],
    application_id: data?.application_id ?? null,
    application_code: data?.application_code ?? "",
    application_visa_type_id: data?.application_visa_type_id ?? "",
    application_visa_type_value:
        data?.application_visa_type?.visa_type_value ?? "",

    application_country_id: data?.application_country_id ?? "",
    application_country_value: data?.application_country?.name ?? "",

    application_submission_date: data?.application_submission_date ?? "",
    application_status_id: data?.application_status_id ?? "",
    application_status_value:
        data?.application_status?.application_status_value ?? "",

    application_start_date: data?.application_start_date ?? "",
    application_expiry_date: data?.application_expiry_date ?? "",
    application_duration: data?.application_duration ?? "",

    number_of_entries_id: data?.number_of_entries_id ?? "",
    number_of_entries_value:
        data?.number_of_entries?.number_of_entries_value ?? "",

    issuing_authority: data?.issuing_authority ?? "",
    reference_number: data?.reference_number ?? "",
    application_center: data?.application_center ?? "",
    case_manager: data?.case_manager ?? "",
    assigned_team: data?.assigned_team ?? "",
    client_contact: data?.client_contact ?? "",
});